import { initPrism } from './prism';
import { initTocbot } from './tocbot';
import { initCodeCopy } from './code-copy';
import mediumZoom from 'medium-zoom'

initPrism();
initTocbot();
initCodeCopy();
mediumZoom(".kg-image-card img")